import { useEffect, useRef, useState } from "react";
import { toast } from "sonner";
import { Loader2, Paperclip, X, Upload } from "lucide-react";
import { Button } from "../ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "../ui/dialog";
import { api, fileUrl } from "../../lib/api";

export const RentalFilesField = ({ value = [], onChange, testid = "rental-files" }) => {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);
  const pick = async (files) => {
    setBusy(true);
    let cur = [...value];
    try {
      for (const file of Array.from(files || [])) {
        const r = await api.uploadFile(file);
        cur = [...cur, { id: r.attachment_id, name: r.attachment_name || file.name }];
        onChange(cur);
      }
    } catch (e) { toast.error(e?.response?.data?.detail || "تعذّر رفع الملف"); } finally { setBusy(false); }
  };
  return (
    <div className="space-y-1.5" data-testid={testid}>
      <input ref={ref} type="file" hidden multiple accept="image/*,application/pdf" data-testid={`${testid}-input`}
        onChange={(e) => { pick(e.target.files); e.target.value = ""; }} />
      <Button type="button" variant="outline" size="sm" disabled={busy} onClick={() => ref.current?.click()} className="gap-1.5" data-testid={`${testid}-add`}>
        {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Upload className="h-4 w-4" />} إضافة ملف
      </Button>
      {value.map((a, i) => (
        <div key={a.id} className="flex items-center gap-2 rounded-lg border border-slate-200 bg-slate-50 px-2 py-1.5 text-xs" data-testid={`${testid}-item-${i}`}>
          <Paperclip className="h-3.5 w-3.5 text-slate-400" />
          <a href={fileUrl(a.id)} target="_blank" rel="noreferrer" className="flex-1 truncate text-blue-700 hover:underline">{a.name || "ملف"}</a>
          <button type="button" onClick={() => onChange(value.filter((_, j) => j !== i))} data-testid={`${testid}-remove-${i}`}><X className="h-3.5 w-3.5 text-slate-400 hover:text-red-500" /></button>
        </div>
      ))}
    </div>
  );
};

export const RentalFilesDialog = ({ contract, onClose, onSaved }) => {
  const [files, setFiles] = useState([]);
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (contract) setFiles(contract.attachments || []); }, [contract]);
  const save = async () => {
    setBusy(true);
    try { await api.setRentalContractFiles(contract.id, files); toast.success("تم حفظ ملفات العقد"); onSaved?.(); onClose(); }
    catch (e) { toast.error(e?.response?.data?.detail || "تعذّر الحفظ"); } finally { setBusy(false); }
  };
  return (
    <Dialog open={!!contract} onOpenChange={(v) => !v && onClose()}>
      <DialogContent dir="rtl" className="max-w-md" data-testid="rental-files-dialog">
        <DialogHeader className="text-right"><DialogTitle>ملفات العقد {contract?.number}</DialogTitle><DialogDescription>أرفق صورة العقد الموقّع أو الهوية أو أي مستند.</DialogDescription></DialogHeader>
        <RentalFilesField value={files} onChange={setFiles} testid="rental-files-edit" />
        <Button disabled={busy} onClick={save} className="gap-1.5" data-testid="rental-files-save">{busy && <Loader2 className="h-4 w-4 animate-spin" />} حفظ</Button>
      </DialogContent>
    </Dialog>
  );
};
